import propertyOrNull from '@99designs/utils/app/propertyOrNull';
import user from '../models/user';

export default {
    create,
    defaultProperties,
    fromJSON,
};

function create(properties) {
    return Object.assign({}, defaultProperties(), properties);
}

function defaultProperties() {
    return {
        designId: null,
        size: null,
        width: null,
        height: null,
        createdAt: new Date().toString(),
        downloadUrl: null,
        previewUrl: null,
        showUrl: null,
        s3Bucket: null,
        s3Object: null,
        creator: null,
        permission: {
            canAnnotate: false,
            canComment: false,
            canView: false,
            canSketch: false,
            canViewComments: false,
            canViewSketches: false,
        },
        links: {
            self: null,
            delete: null,
            comments: null,
            createComment: null,
            sketches: null,
            updateSketches: null,
        },
    };
}

// Translate from HAL API to local data structure
function fromJSON(json) {
    if (!json) {
        return null;
    }

    const defaults = defaultProperties();
    const data = {
        designId: propertyOrNull(json, 'designId'),
        creator: user.fromJSON(json._embedded.creator),
        permission: Object.assign({}, defaults.permission, json._embedded.permission || {}),
        links: {
            self: propertyOrNull(json._links.self, 'href'),
            delete: propertyOrNull(json._links.delete, 'href'),
            comments: propertyOrNull(json._links.messages, 'href'),
            createComment: propertyOrNull(json._links.createMessage, 'href'),
            sketches: propertyOrNull(json._links.sketches, 'href'),
            updateSketches: propertyOrNull(json._links.updateSketches, 'href'),
        },
    };

    const keys = [
        'name',
        'isDeliverable',
        'isDeleted',
        'size',
        'width',
        'height',
        's3Bucket',
        's3Object',
        'createdAt',
        'downloadUrl',
        'previewUrl',
        'showUrl',
    ];

    keys.forEach(k => (data[k] = propertyOrNull(json, k)));
    return data;
}



// WEBPACK FOOTER //
// ./~/@99designs/ddo/models/design.js